import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, shareReplay } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { EmpresaFacturadora } from '../../../../models/maestros/empresa-facturadora.model';

@Injectable({
  providedIn: 'root',
})
export class EmpresaFacturadoraService {
  private readonly apiUrl = environment.apiUrl;
  private readonly endpoint = `${this.apiUrl}/maestras/empresa-facturadora`;

  private empresasFacturadorasVigor?: Observable<EmpresaFacturadora[]>;
  private empresasFacturadorasTodos?: Observable<EmpresaFacturadora[]>;

  constructor(private readonly http: HttpClient) {}

  getEmpresasFacturadorasVigor(): Observable<EmpresaFacturadora[]> {
    if (!this.empresasFacturadorasVigor) {
      this.empresasFacturadorasVigor = this.http.get<EmpresaFacturadora[]>(this.endpoint).pipe(
        shareReplay(1), // Cachear el último valor emitido
        catchError((error) => {
          console.error('EmpresaFacturadoraService - Error fetching data:', error);
          throw error;
        })
      );
    }
    return this.empresasFacturadorasVigor;
  }

  getEmpresasFacturadorasTodos(): Observable<EmpresaFacturadora[]> {
    if (!this.empresasFacturadorasTodos) {
      this.empresasFacturadorasTodos = this.http.get<EmpresaFacturadora[]>(this.endpoint.concat('/todos')).pipe(
        shareReplay(1), // Cachear el último valor emitido
        catchError((error) => {
          console.error('EmpresaFacturadoraService - Error fetching data:', error);
          throw error;
        })
      );
    }
    return this.empresasFacturadorasTodos;
  }

  setComboEmpresasFacturadoras(empresaFacturadoras: EmpresaFacturadora[]): void {
    this.getEmpresasFacturadorasVigor().subscribe({
      next: (data) => {
        empresaFacturadoras.push(...data);
      },
      error: (error) => {
        console.error('EmpresaFacturadoraService - Error fetching data:', error);
      },
    });
  }
}
